import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CTable,
  CTableRow,
  CTableBody,
  CTableDataCell,
  CModalHeader,
} from '@coreui/react'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail } from 'src/views/utils/helper'
import ReactDragListView from 'react-drag-listview/lib/index.js'
import { isEmpty } from 'lodash'
import PlusIcon from '../../../assets/plus-icon.svg'
import EditIcon from '../../../assets/edit-icon.svg'
import TrashIcon from '../../../assets/trash-icon.svg'
import SixDots from '../../../assets/six-dots.svg'
import CopyLight from '../../../assets/copy-light.svg'
import DeleteModal from 'src/components/DeleteModal/DeleteModal'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'
import { AppContext } from 'src/views/context/app'
import Loading from 'react-fullscreen-loading'
import ExtensiveCarouselSimpleCardModal from './extensiveCarouselSimpleCardModal'
import PaintBrushIcon from '../../../assets/paint-brush-icon.svg'
import DesignSettingOverlay from '../designSettingOverlay'

const ExtensiveCarouselSimpleModal = ({
  componentData,
  modifyData,
  onCancel,
  isAdvancedEditAllowed,
}) => {
  const { userSessionObj } = useContext(GlobalContext)
  const { loader, setLoader } = useContext(AppContext)

  const [title, setTitle] = useState('')
  const [slidesData, setSlidesData] = useState([])

  const [cardModal, setCardModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedCardIndex, setSelectedCardIndex] = useState('')
  const [slideObj, setSlideObj] = useState({})
  const [styleConfig, setStyleConfig] = useState({})
  const [designSettingOptions, setDesignSettingOptions] = useState([])

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    if (!isEmpty(componentData?.data?.slide_data)) {
      setSlidesData(componentData?.data?.slide_data)
      //   setAutoSlide(componentData?.data?.auto_slide)
      setTitle(componentData?.data?.heading)
      if (componentData?.data?.style_config) {
        setStyleConfig(componentData?.data?.style_config)
      }
    }
  }, [])

  const copyCard = (idx) => {
    let tempslidesDataArr = slidesData
    let copyObj = slidesData[idx]
    tempslidesDataArr.splice(idx + 1, 0, copyObj)
    setSlidesData([...tempslidesDataArr])
  }

  const deleteCard = (index) => {
    setSelectedCardIndex(index)
    setDeleteModal(true)
  }

  const onDeleteCard = (index) => {
    setSlidesData((prevData) => prevData.filter((data, idx) => idx !== index))
    setDeleteModal(false)
    setSelectedCardIndex('')
  }

  const handleSave = () => {
    let elementObj = {
      heading: title,
      //   auto_slide: autoSlide,
      slide_data: slidesData,
      style_config: styleConfig,
    }

    modifyData(componentData.id, elementObj)
  }

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const data = [...slidesData]
      const item = data.splice(fromIndex, 1)[0]
      data.splice(toIndex, 0, item)
      setSlidesData([...data])
    },
    handleSelector: '',
  }

  /* Add card code */
  const addNewCard = () => {
    setCardModal(true)
  }

  const editCard = (index) => {
    setSlideObj(slidesData[index])
    setSelectedCardIndex(index)
    setCardModal(true)
  }
  const addCallback = (data) => {
    let tempArr = [...slidesData]
    tempArr.push(data)
    setSlidesData(tempArr)
  }
  const updateCallback = (data) => {
    let tempArr = [...slidesData]
    tempArr[selectedCardIndex] = data
    setSlidesData(tempArr)
  }

  const getStyleConfig = (keyArr = []) => {
    if (!componentData?.data?.style_config) {
      return []
    }
    let stylesArr = []
    for (let i = 0; i < keyArr.length; i++) {
      const key = keyArr[i]
      let styleObj = componentData?.data?.style_config[key]
      stylesArr.push(styleObj)
    }
    return stylesArr
  }

  const handleStyleSave = (data) => {
    let tempStyleObj = styleConfig
    for (let i = 0; i < data.length; i++) {
      const ele = data[i]
      tempStyleObj[ele.key] = ele
    }
    setStyleConfig({ ...tempStyleObj })
    setDesignSettingOptions([])
  }
  return (
    <>
      {cardModal && (
        <ExtensiveCarouselSimpleCardModal
          cancelCardModal={() => {
            setSelectedCardIndex('')
            setSlideObj({})
            setCardModal(false)
          }}
          slideObj={slideObj}
          addCallback={addCallback}
          updateCallback={updateCallback}
          isEdit={!isEmpty(slideObj)}
          categoryList={categoryList ? categoryList?.data : []}
        />
      )}
      <CModal size="lg" className="" visible={true}>
        {!isEmpty(designSettingOptions) && (
          <DesignSettingOverlay
            width={'36%'}
            options={designSettingOptions}
            onCancel={() => setDesignSettingOptions([])}
            handleSave={(data) => handleStyleSave(data)}
          />
        )}
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader
          style={{ borderBottom: 0 }}
          className="d-flex flex-column justify-content-center mt-3 px-5"
        >
          <div className="d-flex justify-content-center w-100 mb-2">
            <p style={{ fontSize: '1.2rem' }} className="mb-0 mx-2">
              <b style={{ fontWeight: '500' }}>Popular VR Games Editor</b>
            </p>
            {componentData?.data?.style_config && isAdvancedEditAllowed && (
              <div
                className={`h-[30px] w-[30px] d-flex justify-content-center align-items-center rounded-full overflow-hidden "`}
              >
                <img
                  src={PaintBrushIcon}
                  alt="PaintBrushIcon"
                  className="cursor-pointer w-full h-full"
                  onClick={() => {
                    setDesignSettingOptions(
                      getStyleConfig(['component_background', 'heading', 'card_heading_style']),
                    )
                  }}
                />
              </div>
            )}
          </div>

          <div className="w-100 px-1">
            <h6 style={{ fontSize: '14px' }}>HEADING</h6>
            <CustomDescriptionBox
              limit={45}
              rows={1}
              value={title}
              onChange={(value) => setTitle(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
              useFormInput={true}
            />
          </div>
          <div
            style={{ fontSize: '1rem' }}
            className="d-flex justify-content-between w-100 px-1 -mb-4"
          >
            <h6 style={{ fontSize: '14px' }}>
              SLIDES <br />
              <span className="font-thin text-xs">Drag to Re-arrange</span>
            </h6>
            {/* <div className="d-flex align-items-end">
              <span style={{ fontSize: '13px' }} className="mr-2 mb-1">
                Auto Slide
              </span>
              <CFormSwitch
                label=""
                value={autoSlide}
                checked={autoSlide}
                valid={autoSlide}
                id="buttonEnable"
                onChange={(e) => setAutoSlide(e.target.checked)}
              />
            </div> */}
          </div>
        </CModalHeader>
        <CModalBody
          style={{ height: '63vh' }}
          className=" static-scrollbar-class d-flex flex-column justify-content-between px-5 "
        >
          <div
            className="d-flex justify-content-center h-full flex-shrink-0"
            style={{ width: '100%', minHeight: '100%' }}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                overflowX: 'hidden',
                overflowY: 'auto',
              }}
              className="flex flex-column justify-content-start align-items-center p-2 -mt-3 bg-[#e9e9e9] rounded-md outline outline-1 outline-gray-400 scrollbar"
            >
              <ReactDragListView {...dragProps}>
                <CTable
                  className="mt-1 w-full"
                  style={{
                    borderCollapse: 'separate',
                    borderSpacing: '0 13px',
                  }}
                >
                  <CTableBody>
                    {!isEmpty(slidesData) ? (
                      slidesData.map((item, index) => (
                        <CTableRow
                          key={index}
                          className="overflow-hidden bg-[#fff] rounded outline outline-1 outline-gray-400 hover:outline-[#2172eb] hover:outline-2"
                          style={{
                            borderRadius: '10px',
                            cursor: 'all-scroll',
                          }}
                        >
                          <CTableDataCell
                            style={{ width: '4%' }}
                            align="middle"
                            className="hover:cursor-move"
                          >
                            <img src={SixDots} alt="" />
                          </CTableDataCell>
                          <CTableDataCell style={{ width: '15%', height: '100%' }} align="middle">
                            <img
                              src={getThumbnail(
                                userSessionObj?.session_data?.cf_domain_name,
                                item.image_s3key,
                              )}
                              alt=""
                              className="w-100 h-100"
                              // style={{ height: '56px', width: '107px' }}
                            />
                          </CTableDataCell>
                          <CTableDataCell style={{ width: 'auto' }} align="middle">
                            <div className="-mt-1 -mb-5" style={{ lineHeight: '13px' }}>
                              <p
                                className="font-medium line-clamp-1"
                                style={{ fontSize: '13px', lineHeight: '13px' }}
                              >
                                {item.heading}
                              </p>
                            </div>
                          </CTableDataCell>
                          <CTableDataCell
                            align="middle"
                            style={{ textAlign: 'center', width: '5%' }}
                          >
                            <div
                              className=" h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer shadow-2xl"
                              onClick={() => editCard(index)}
                              style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                            >
                              <img src={EditIcon} className="w-[17px] h-[17px] " alt="editicon" />
                            </div>
                          </CTableDataCell>
                          <CTableDataCell
                            align="middle"
                            style={{ textAlign: 'center', width: '5%' }}
                          >
                            <div
                              className=" h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer shadow-2xl"
                              onClick={() => copyCard(index)}
                              style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                            >
                              <img src={CopyLight} className="w-[17px] h-[17px] " alt="copyIcon" />
                            </div>
                          </CTableDataCell>
                          <CTableDataCell
                            align="middle"
                            style={{ textAlign: 'center', width: '5%' }}
                          >
                            <div
                              className="mr-4 h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer shadow-2xl"
                              onClick={() => deleteCard(index)}
                              style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                            >
                              <img src={TrashIcon} className="w-[17px] h-[17px]" alt="trashicon" />
                            </div>
                          </CTableDataCell>
                        </CTableRow>
                      ))
                    ) : (
                      <CTableRow>
                        <CTableDataCell colSpan="6">
                          <p>No Data Found</p>
                        </CTableDataCell>
                      </CTableRow>
                    )}
                  </CTableBody>
                </CTable>
              </ReactDragListView>
              <div
                className="overflow-hidden bg-[#fff] rounded outline outline-1 outline-gray-400 w-full flex flex-col justify-center items-center cursor-pointer flex-shrink-0 p-3 -mt-2 mb-2"
                style={{
                  borderRadius: '10px',
                }}
                onClick={() => addNewCard()}
              >
                <div
                  className="h-[24px] w-[24px] rounded-full bg-[#2172eb] flex justify-center items-center shadow"
                  style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                >
                  <img src={PlusIcon} className="w-[15px] h-[15px]" alt="trashicon" />
                </div>
                <span className="text-sm font-medium mt-2 ">Add a new Slide</span>
              </div>
              {deleteModal && (
                <DeleteModal
                  openModal={deleteModal}
                  title={`Are you sure you want to delete this Slide ?`}
                  confirmButtonText={`Yes`}
                  onCancel={() => {
                    setSelectedCardIndex('')
                    setDeleteModal(false)
                  }}
                  onConfirm={() => onDeleteCard(selectedCardIndex)}
                />
              )}
            </div>
          </div>
        </CModalBody>
        <CModalFooter
          style={{ borderTop: 0 }}
          className="d-flex justify-content-between align-items-start"
        >
          <div style={{ marginLeft: '4.5%' }} className="d-flex justify-content-start ">
            <span style={{ fontSize: '11px' }}>
              * Leave a section blank to remove it from the component. Do not fill any details.
            </span>
          </div>
          <div style={{ marginRight: '5%' }} className="pb-3">
            <CButton
              style={{ color: 'black', border: '1px solid black', fontSize: '1.1rem' }}
              className="mx-4 bg-white rounded-1 btn-focus-none"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton
              style={{ fontSize: '1.1rem' }}
              className=" bg-black rounded-1 btn-focus-none px-3"
              onClick={handleSave}
            >
              Save
            </CButton>
          </div>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ExtensiveCarouselSimpleModal
